/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from '@ngrx/store';
import { SystemManagerActionNames } from './system-manager-action-names';
import { SystemInfo } from 'libs/sysque/toolbelt/data-access/src/lib/domain/system-info';
import { SystemManagerExportReturnCodes } from '../../../../../../shared/ui/src/lib/enums/system-manager-export-return-codes';

export const GetVisibleInvisibleSystems = createAction(
  SystemManagerActionNames.GetVisibleInvisibleSystems()
);

export const GetVisibleInvisibleSystemsSuccess = createAction(
  SystemManagerActionNames.GetVisibleInvisibleSystemsSuccess(),
  props<{ visibleInvisibleSystems: SystemInfo[] }>()
);

export const GetReturnCodeAfterExport = createAction(
  SystemManagerActionNames.GetReturnCodeAfterExport(),
  props<{ selectedSystems: string[] }>()
)

export const GetReturnCodeAfterExportSuccess = createAction(
  SystemManagerActionNames.GetVisibleInvisibleSystemsSuccess(),
  props<{ returnCodeExport: SystemManagerExportReturnCodes }>()
);

export const BrowseClick = createAction(
  SystemManagerActionNames.BrowseClick()
);

export const BrowseClickSuccess = createAction(
  SystemManagerActionNames.BrowseClickSuccess(),
  props<{ response: string }>()
);

export const onSystemManagerItemClickAction = createAction(
  SystemManagerActionNames.onSystemManagerItemClickAction(),
  props<{ route: string, width: number; height: number }>()
);

export const onSystemManagerItemClickActionSuccess = createAction( SystemManagerActionNames.onSystemManagerItemClickActionSuccess() );